;(() => {
  class PdpGallery extends XThemeBaseElement {
    mount() {
      this.track = this.querySelector('[data-gallery-track]')
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')]
      this.dots = [...this.querySelectorAll('[data-gallery-dot]')]
      if (!this.track || !this.slides.length) return

      if (this.slides.length > 1) {
        this.track.addEventListener('scroll', () => this.updateActive(), {
          passive: true,
          signal: this._ac.signal,
        })
      }
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.slides[Number(dot.dataset.galleryDot)]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          })
        }, { signal: this._ac.signal })
      })

      if (this.dataset.galleryClickAction !== 'none') {
        this.track.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault()
            return
          }

          const slide = event.target.closest('[data-gallery-slide]')
          if (!slide) return
          event.preventDefault()
          this.openViewer(Number(slide.dataset.galleryIndex))
        }, { signal: this._ac.signal })

        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return
          const slide = event.target.closest('[data-gallery-slide]')
          if (!slide) return
          event.preventDefault()
          this.openViewer(Number(slide.dataset.galleryIndex))
        }, { signal: this._ac.signal })

        this.track.addEventListener('pointerdown', (event) => {
          this.pointerStart = { x: event.clientX, y: event.clientY }
        }, { passive: true, signal: this._ac.signal })
        this.track.addEventListener('pointerup', (event) => {
          if (!this.pointerStart) return
          if (Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 10) {
            this.suppressClickUntil = performance.now() + 400
          }
          this.pointerStart = null
        }, { passive: true, signal: this._ac.signal })
        this.track.addEventListener('pointercancel', () => { this.pointerStart = null }, {
          signal: this._ac.signal,
        })
      }

      this.updateActive()
    }

    openViewer(index) {
      const pswpElement = document.querySelector('.pswp_t4_js')
      if (!pswpElement || !window.PhotoSwipe || !window.PhotoSwipeUI_Default) return

      const items = this.slides.map((slide) => {
        const image = slide.querySelector('img')
        return {
          src: image.dataset.gallerySource,
          msrc: image.currentSrc || image.src,
          w: Number(image.dataset.galleryWidth),
          h: Number(image.dataset.galleryHeight),
          title: image.alt,
        }
      })

      const gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, {
        index,
        history: false,
        loop: true,
        bgOpacity: 0.96,
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: true,
        pinchToClose: true,
        getThumbBoundsFn: (itemIndex) => {
          const image = this.slides[itemIndex]?.querySelector('img')
          if (!image) return undefined
          const rect = image.getBoundingClientRect()
          return { x: rect.left, y: rect.top + window.pageYOffset, w: rect.width }
        },
      })
      gallery.init()
    }

    updateActive() {
      if (!this.track || !this.slides.length) return
      const current = Math.round(this.track.scrollLeft / this.slides[0].offsetWidth)
      this.dots.forEach((dot, index) => {
        const active = index === current
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
    }
  }

  if (!window.customElements.get('x-pdp-gallery')) {
    window.customElements.define('x-pdp-gallery', PdpGallery)
  }
})();
